import { Barcode } from 'src/api/models'

import { API } from './types'

export class BarcodeAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  url = (barcode: Barcode) => {
    return `${process.env.REACT_APP_API_URL}/logistics/barcodes/${barcode.type}/${barcode.barcode}.png`
  }
}
